import {
    stakeholderApplyFilterCriteria,
    stakeholderClearFilterCriteria,
    stakeholderSetFilter
} from "../../../actions/stakeholder-actions"
import StakeholderFilterFormContainer from "./StakeholderFilterFormContainer"
import buildFilterWidgetContainer from "../../common/build-filter-widget-container"

export default buildFilterWidgetContainer(
    StakeholderFilterFormContainer,
    stakeholderClearFilterCriteria,
    stakeholderApplyFilterCriteria,
    stakeholderSetFilter
)
